import _createForOfIteratorHelper from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import menuMixin from '../mixin/menu';
export default {
  mixins: [menuMixin],
  watch: {
    currentFirstIndex: {
      handler: function handler(val) {
        this.SETcurrentFirstName(this.$i18n.locale === 'zh-chs' ? this.aside[val].title : this.aside[val].title_en);
      }
    },
    '$i18n.locale': {
      handler: function handler(val) {
        console.log('watch', val);
        console.log('menuList', this.menuList);
        this.deepAside(this.aside, val); // this.aside.forEach(v=>{
        //   if(val === 'en'){
        //     v.titleName = this.formaENtitle(v.title_en) 
        //   }else if(val === 'zh-chs'){
        //     v.titleName = v.title
        //   }          
        // })
        // this.menuList.forEach(v=>{
        //   if(val === 'en'){
        //     v.titleName = v.title_en
        //   }else if(val === 'zh-chs'){
        //     v.titleName = v.title
        //   }          
        // })        

        this.SETcurrentFirstName(val === 'zh-chs' ? this.aside[this.currentFirstIndex].title : this.aside[this.currentFirstIndex].title_en);
        this.$forceUpdate();
      },
      immediate: true
    },
    fullPath: {
      handler: function handler(value) {
        var res = this.deepMainMenuIndex(this.aside, function (item) {
          return item.path === value;
        });
        var index = this.aside.findIndex(function (v) {
          return v.title === res[0].title;
        });
        this.SETcurrentFirstName(res[0].title);
        this.handleItem(index);
      } // immediate: true

    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/menu', ['currentFirstName'])), {}, {
    fullPath: function fullPath() {
      // console.log('菜单',this.$route);
      return this.$route.path;
    },
    aside: function aside() {
      return this.$store.state.d2admin.menu.aside.map(function (item) {
        item.titleName = item.title;
        return item;
      });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // console.log('菜单',this.aside);
    this.deepAside(this.aside, this.$i18n.locale);
    console.log('aside', this.aside);
    this.$nextTick(function () {
      _this.setCurrent(_this.$route.fullPath); // console.log('fullPath',this.$route.path);
      // console.log('菜单',this.$store.state.d2admin.menu.aside);
      // console.log('this.aside',this.aside);
      // console.log('this.fullPath',this.fullPath);


      var res = _this.deepMainMenuIndex(_this.aside, function (item) {
        return item.path === _this.fullPath;
      });

      var index = _this.aside.findIndex(function (v) {
        return v.title === res[0].title;
      });

      _this.SETcurrentFirstName(res[0].title);

      _this.handleItem(index);
    });
    this.Bus.on('onUnfoldBtn', function () {
      _this.isShowMenu = !_this.isShowMenu;

      _this.openMenu();
    });
  },
  data: function data() {
    return {
      // activeIndex:null,
      isShowMenu: false,
      blockList: [1, 2, 3],
      bgBlockEl: null,
      menuList: [],
      currentFirstIndex: 0
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('d2admin/menu', ['SETcurrentFirstName'])), {}, {
    formaENtitle: function formaENtitle(title_en) {
      switch (title_en) {
        case 'SupplierModule':
          return 'SM';

        case 'System Management':
          return 'SM';

        case 'reportCenter':
          return 'RC';

        default:
          return title_en;
      }
    },
    deepAside: function deepAside(tree, locale) {
      var _iterator = _createForOfIteratorHelper(tree),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.children) {
            console.log();
            this.deepAside(item.children, locale);
          }

          if (locale === 'en') {
            item.titleName = this.formaENtitle(item.title_en);
          } else if (locale === 'zh-chs') {
            item.titleName = item.title;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    deepMainMenuIndex: function deepMainMenuIndex(tree, func) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (!tree) {
        return [];
      }

      var _iterator2 = _createForOfIteratorHelper(tree),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          path.push(item);

          if (func(item)) {
            return path;
          }

          if (item.children) {
            var res = this.deepMainMenuIndex(item.children, func, path);

            if (res.length) {
              return res;
            }
          }

          path.pop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return [];
    },
    // 展开menu
    openMenu: function openMenu() {
      var title = document.querySelector('#menuTitle'); // console.log('菜单标题',title.style);
      // title.style.visibility = 'visible'

      if (this.isShowMenu === true) {
        // title.style.visibility = 'visible'
        var munu = document.querySelector('.menu-wrap');
        munu.style.width = 210 + 'px';
        title.style['font-size'] = 18 + 'px';
        title.style.color = '#001529';
      } else {
        // title.style.visibility = 'hidden'
        var _munu = document.querySelector('.menu-wrap');

        _munu.style.width = 0 + 'px';
        title.style['font-size'] = 0 + 'px';
        title.style.color = '#ffffff';
      }
    },
    // 设置选中
    setCurrent: function setCurrent(fullPath) {
      if (fullPath) {
        this.handleItem(0);
        this.isShowMenu = !this.isShowMenu; // this.openMenu()
      }
    },
    // 点击一级
    handleItem: function handleItem(index) {
      // console.log('isShowMenu',this.isShowMenu);
      this.currentFirstIndex = index;
      this.transition(index);
      this.menuList = this.aside[index].children;
      this.SETcurrentFirstName(this.$i18n.locale === 'zh-chs' ? this.aside[index].title : this.aside[index].title_en);

      if (this.isShowMenu === false) {
        this.isShowMenu = true;
        this.openMenu();
      }
    },
    transition: function transition(index) {
      var itemList = document.querySelectorAll('.item');
      itemList.forEach(function (item) {
        item.children[0].style.width = 0 + 'px';
      });
      itemList[index].children[0].style.width = 100 + '%';
    },
    menuSelect: function menuSelect() {}
  })
};